import axios from "axios";

export default {
  data() {
    return {
      organizations: [],
      researchAreas: [],
      projectTypes: [],
      funderPrograms: [],
      namePersons: []
    };
  },

  methods: {
    getNamePersons() {
      let path = this.$store.state.endpoint + "/personName";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            this.namePersons.push({
              id: item.id,
              name:
                item.preferred_name.given_name +
                " " +
                item.preferred_name.family_name
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getFunderPrograms() {
      let path = this.$store.state.endpoint + "/funderProgram";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(funder_program => {
            this.funderPrograms.push({
              id: funder_program.id,
              name: funder_program.internal_name
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getOrganizations() {
      let path = this.$store.state.endpoint + "/organization";
      axios
        .get(path)
        .then(response => {
          this.organizations = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getResearchAreas() {
      let path = this.$store.state.endpoint + "/researchArea";
      axios
        .get(path)
        .then(response => {
          this.researchAreas = response.data.filter(
            area => !(area.closed || area.deprecated)
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAllResearchAreas() {
      let path = this.$store.state.endpoint + "/researchArea";
      axios
        .get(path)
        .then(response => {
          this.researchAreas = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getProjectTypes() {
      let path = this.$store.state.endpoint + "/utils/projectTypes";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(type => {
            this.projectTypes.push({
              text: this.$t("project.types." + type),
              value: type
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
